import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { useAuthToken, useMutation } from '..';

interface UseCurationRejectProps {
  curationId: string;
  onSuccess: TypeAny;
  reason: string;
}

export function useCurationReject({ curationId, onSuccess, reason }: UseCurationRejectProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const { isLoading, mutate, error, data } = useMutation({
    mutationKey: 'client-curation-reject',
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/client/curation/${curationId}/reject`,
        body: { reason },
        token
      }).then((response: Api.Client.Curation[] | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    onSuccess
  });

  return {
    data: data || {},
    isLoading,
    mutate,
    error
  };
}
